import { render, staticRenderFns } from "./NilCorrCustomerDetail.vue?vue&type=template&id=3f015c88&scoped=true"
import script from "./NilCorrCustomerDetail.vue?vue&type=script&lang=js"
export * from "./NilCorrCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./NilCorrCustomerDetail.vue?vue&type=style&index=0&id=3f015c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f015c88",
  null
  
)

export default component.exports